import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-film-icon lucide-film",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 18,
			height: 18,
			x: 3,
			y: 3,
			rx: 2
		}),
		/* @__PURE__ */ _jsx("path", { d: "M7 3v18" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 7.5h4" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 12h18" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 16.5h4" }),
		/* @__PURE__ */ _jsx("path", { d: "M17 3v18" }),
		/* @__PURE__ */ _jsx("path", { d: "M17 7.5h4" }),
		/* @__PURE__ */ _jsx("path", { d: "M17 16.5h4" })
	]
});
export default SvgFilm;
